module.exports = __webpack_public_path__ + "static/img/01.0496ab1a.png";